import { withNavigation }      from 'components/App/withNavigation';
import { WithNavigationProps } from 'components/App/withNavigation';
import React                   from 'react';
import { Button }              from 'antd';
import PublicLayout            from 'containers/Security/PublicLayout';
import currentSession          from 'utils/currentSession';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

class Error extends React.Component<WithNavigationProps> {
  public render() {
    return (
      <PublicLayout>
        <h1>
          <FormattedMessageWrapper id="Erreur !" />
        </h1>
        <h2>
          <FormattedMessageWrapper id="Désolé. Un problème est survenu." />
        </h2>
        <h3>
          <FormattedMessageWrapper id="Veuillez réeessayer ou vous (re)connecter." />
        </h3>
        <br />
        <Button htmlType="button" onClick={this.redirectToLogin}>
          <FormattedMessageWrapper id="Page connexion" />
        </Button>
      </PublicLayout>
    );
  }

  private redirectToLogin = () => {
    currentSession.logout().then();
    this.props.navigate('/login');
  };
}

const ErrorWithNavigation = withNavigation(Error);

export default ErrorWithNavigation;